import { Uuid } from '@core/uuid/uuid';

export class ImageFile {
  constructor(
    readonly id: Uuid,
    readonly url: string,
  ) {}
}
